import colors from "assets/theme/base/colors";

const { info, success, warning } = colors;

export const lineChartDataDashboard = [
  {
    name: "Mobile apps",
    data: [50, 25, 30, 22, 50, 25, 30, 23, 30, 35, 25, 40],
  },
  {
    name: "Websites",
    data: [200, 230, 300, 350, 370, 420, 550, 350, 400, 500, 330, 550],
  },
];

export const FreightIndexZones = [
  { value: "India", label: "Pan-India", isFixed: true },
  { value: "North", label: "North" },
  { value: "East", label: "East 🔒", isDisabled: false, isOpenMenu: true  },
  { value: "West", label: "West 🔒", isDisabled: false, isOpenMenu: true  },
  { value: "South", label: "South 🔒", isDisabled: false, isOpenMenu: true  },
];

export const FreightIndexZonesLoggedIn = [
  { value: "India", label: "Pan-India", isFixed: true },
  { value: "North", label: "North" },
  { value: "East", label: "East" },
  { value: "West", label: "West" },
  { value: "South", label: "South" },
];

export const FreightIndexZonesTimePeriods = [
  { value: 6, label: "6 months" },
  { value: 12, label: "12 months" },
  { value: 18, label: "18 months 🔒", isDisabled: false, isOpenMenu: true },
  { value: 24, label: "24 months 🔒", isDisabled: false, isOpenMenu: true }
];
export const FreightIndexZonesTimePeriodsLoggedIn = [
  { value: 6, label: "6 months" },
  { value: 12, label: "12 months" },
  { value: 18, label: "18 months" },
  { value: 24, label: "24 months" }
];

export const FreightIndexVehicleTypes = [
  { value: "Open Body", label: "Open Body" },
  { value: "Trailer", label: "Trailer 🔒", isDisabled: false, isOpenMenu: true },
  { value: "Closed Body/Container", label: "Closed Body/Container 🔒", isDisabled: false, isOpenMenu: true }
];
export const FreightIndexVehicleTypesLoggedIn = [
  { value: "Open Body", label: "Open Body" },
  { value: "Trailer", label: "Trailer" },
  { value: "Closed Body/Container", label: "Closed Body/Container" }
];

export const lineChartOptionsDashboard = {
  chart: {
    markers: {
      size: 3,
      colors: info.main,
      strokeColors: info.main,
      strokeWidth: 2,
      strokeOpacity: 0.9,
      strokeDashArray: 0,
      fillOpacity: 1,
      discrete: [],
      shape: "circle",
      radius: 2,
      offsetX: 0,
      offsetY: 0,
      showNullDataPoints: true,
    },
    toolbar: {
      show: true,
      offsetX: "100%",
    },
  },
  tooltip: {
    theme: "dark",
    y: {
        formatter: function (val) {
          return "₹ " + val
      },
    },
    x: {
      show: false
    },
  },
  dataLabels: {
    enabled: false,
    formatter: function (val) {
      return "₹ " + val
    },
  },
  stroke: {
    curve: "smooth",
  },
  xaxis: {
    //type: "datetime",
    categories: [],
    labels: {
      style: {
        colors: "#696687",
        fontSize: "12px",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: "#696687",
        fontSize: "12px",
      },
    },
  },
  legend: {
    show: true,
    labels: {
        colors: "#696687",
    },
  },
  grid: {
    strokeDashArray: 5,
    borderColor: "#56577A",
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0,
      gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
      inverseColors: true,
      opacityFrom: 0.8,
      opacityTo: 0,
      stops: [],
    },
    colors: ["#666666", info.charts[100],success.main, info.charts[400], warning.main, info.charts[600]],
  },
  colors: ["#666666", info.charts[100], success.main, info.charts[400], warning.main, info.charts[600]],
};
